import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  withStyles,
} from '@material-ui/core';
import PATHS from 'constants/paths';

const ignorePaths = ['/profile', '/userform', '/login', '/logout', '/redirect'];

const styles = () => ({
  root: {
    zIndex: '1301 !important',
  },
});

class GlobalInfo extends React.Component {
  state = {
    open: false,
  };

  componentDidMount() {
    this.openDialog(this.props.pathname);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.pathname !== nextProps.pathname) {
      this.openDialog(nextProps.pathname);
    }
  }

  openDialog = (path) => {
    if (!this.wasOpenOnce && !ignorePaths.includes(path.toLowerCase())) {
      this.setState({ open: true });
      this.wasOpenOnce = true;
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        open={this.state.open && !ignorePaths.includes(this.props.pathname)}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ root: classes.root }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <FormattedMessage
              id="globalInfo.completeProfile"
              defaultMessage="We recommend that you complete your account information to
                increase your credibility against other users on the site."
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus color="primary" onClick={this.handleClose}>
            <FormattedMessage id="Later" defaultMessage="Later" />
          </Button>
          <Button
            onClick={this.handleClose}
            color="primary"
            component={Link}
            to={PATHS.users.profile}
          >
            <FormattedMessage id="globalInfo.completeBtn" defaultMessage="Complete your profile" />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

GlobalInfo.propTypes = {
  pathname: PropTypes.string.isRequired,
  classes: PropTypes.shape({}),
};

export default withStyles(styles)(GlobalInfo);
